import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

/** The same readable source affordance for image and video tools. */
export function PromptSourceButton({ icon, children, className, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { icon: ReactNode }) {
  return <button type="button" {...props} className={cn("studio-prompt-drop", className)}>
    <span className="studio-prompt-drop-icon" aria-hidden="true">{icon}</span><span>{children}</span>
  </button>;
}
